module.exports = __webpack_public_path__ + "media/img/broad-9410ef654a4d73646efa6c65440e10f3.svg";